export class UserPreferences {
    private indicatorYear: number;
    private indicatorQtr: number;

    constructor(storeJson: string) {
        this.PopulateFromJson(storeJson);
    }

    get IndicatorYear(): number { return this.indicatorYear; }
    set IndicatorYear(value: number) { this.indicatorYear = value; }

    get IndicatorQtr(): number { return this.indicatorQtr; }
    set IndicatorQtr(value: number) { this.indicatorQtr = value; }

    private PopulateFromJson(storeJson: string) {
        if (storeJson) {
            const jsonObj = JSON.parse(storeJson);
            this.indicatorYear = jsonObj.indicatorYear;
            this.IndicatorQtr = jsonObj.indicatorQtr;
        }
    }

    public ToJSON(): string {
        const json = JSON.stringify(this);
        return json;
    }
}
